import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonStaffApiServiceService {

  private apiUrl = environment.apiUrl; // Replace with your actual API URL
  constructor(private http: HttpClient) { }

  createStaffProfile(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create`, data);
  }

  updateStaffProfile(data: any, id: number | string): Observable<any> {
    return this.http.post(`${this.apiUrl}user/update/${id}`, data);
  }
  // ::TODO:: Add proper endpoint to delete staff
  deleteStaff(id: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/delete/${id}`);
  }

  getStaffList(role_id: number | string, page?: number, search?: string): Observable<any> {
    let queryParams = new HttpParams();
    if (page) {
      queryParams = queryParams.set('page', page);
    }
    if (search) {
      queryParams = queryParams.set('search', search);
      queryParams = queryParams.set('role', String(role_id));
      return this.http.get(`${this.apiUrl}users/search`, { params: queryParams });
    }
    return this.http.get(`${this.apiUrl}user/type/${role_id}`, { params: queryParams });
  }

  // ::TODO:: Add proper endpoint for fetching staff by ID
  getStaffProfile(id: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/${id}`);
  }

  setStaffAddress(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/address`, data);
  }

  setStaffEducation(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/education`, data);
  }

  setStaffExperience(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/work-experience`, data);
  }

  setStaffAssignCourse(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}assign-course`, data);
  }

  searchStaffs(name?: string, type?: 'HOD' | 'STF' | 'TCH', page?: number) {
    let queryParams = new HttpParams();
    if (name) {
      queryParams = queryParams.set('name', name);
    }
    if (type) {
      queryParams = queryParams.set('role', type);
    }
    if (page !== undefined && page !== null) {
      queryParams = queryParams.set('page', page.toString());
    }
    return this.http.get(`${this.apiUrl}users/search`, { params: queryParams });
  }

  // Fetch all teachers in a single call (per_page=all)
  searchAllTeachers(name?: string, type: 'HOD' | 'STF' | 'TCH' = 'TCH') {
    let queryParams = new HttpParams().set('per_page', 'all');
    if (name) {
      queryParams = queryParams.set('name', name);
    }
    if (type) {
      queryParams = queryParams.set('role', type);
    }
    return this.http.get(`${this.apiUrl}users/search`, { params: queryParams });
  }


}
